
export const getSonglistHash = songArr => {
  // returns a string of song ids to represent a unique id for the songlist
  return songArr.map(song => {return song.id}).join(',');
}

export const stripUrlQueryParams = url => {
  // todo: #mediaQueryParams solve this on the back end instead.
  // for now, strip off the query params. It's not needed, and it's causing a 403 error
  // sometimes when there is a mismatch in the back-end and our cache.
  // clear the mediaQueries to avoid caching issues.
  return url ? url.split('?')[0] : '';
}



// WEBPACK FOOTER //
// ./src/helpers.js